import SignatureViewer from "../global/SignatureViewer";
import Button from "../organism/Button";

function ExistingSignaturePopup({
  imageURL,
  handleChange,
  handleDone,
  buttonTitle,
  submitting = false,
}: {
  imageURL: string;
  buttonTitle: string;
  handleChange: Function;
  handleDone: Function;
  submitting?: boolean;
}): JSX.Element {
  return (
    <div>
      <SignatureViewer
        imageURL={imageURL}
        alt="signature preview"
        containerClassName="mb-6"
        maxHeight="400px"
        maxWidth="100%"
      />
      <div className="flex items-center justify-end">
        <Button
          textInformation={{
            text: "Change",
            fontWeight: "font-semibold",
          }}
          buttonTheme="secondary"
          onClick={() => handleChange()}
          className="mr-4"
          disabled={submitting}
        />
        <Button
          textInformation={{
            text: buttonTitle,
            fontWeight: "font-semibold",
          }}
          buttonTheme="primary"
          onClick={() => handleDone()}
          loading={submitting}
          disabled={submitting}
        />
      </div>
    </div>
  );
}

export default ExistingSignaturePopup;
